import { useContext } from 'react';

import { AppContext, type AppContextValue } from '@/presentation/contexts/app-context.js';

export function useApp(): AppContextValue {
    const ctx = useContext(AppContext);
    if (!ctx) {
        throw new Error('useApp must be used within AppContext.Provider');
    }
    return ctx;
}
